import React from 'react';
import { motion } from 'framer-motion';
import UserNavbar from '../components/UserNavbar';
import PaymentRequestsList from '../components/PaymentRequestsList';

const PaymentRequests = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-secondary-50">
      <UserNavbar />

      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="container mx-auto px-4 py-6 pt-20 md:pt-24 pb-24 md:pb-8"
      >
        <PaymentRequestsList />
      </motion.main>
    </div>
  );
};

export default PaymentRequests;